export default {
    propertiesEventHandler:null,
    setPropertiesEventHandler(handler){
        this.propertiesEventHandler = handler;
    }
}